import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { createFilterOptions } from '@mui/material/Autocomplete';

// Components
import Input from '../../../../components/inputs/input';
import AutoComplete from '../../../../components/inputs/Autocomplete';

const EditDetailModal = ({ detail, onSave, onClose, open, adjustmentTypesOptions }) => {
    const [quantity, setQuantity] = useState(detail.quantity);
    const [adjustmentTypes, setAdjustmentTypes] = useState(detail.adjustmentTypes);

    const handleSave = () => {
        onSave(detail.refId, {
            ...detail,
            quantity,
            adjustmentTypes,
            plannedQuantity: quantity
        });
        onClose();
    }

    const handleNumberChange = (event) => {
        const num = Number.parseInt(event.target.value);
        if (!isNaN(num) && num >= 1)
            setQuantity(num);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Detalle ${detail.refId}`}
            </DialogTitle>
            <DialogContent dividers style={{ minWidth: 430 }}>
                <Grid container spacing={1}>
                    <Grid size={8}>
                        <AutoComplete
                            fullWidth
                            onChange={(e, value) => setAdjustmentTypes(value)}
                            options={adjustmentTypesOptions}
                            value={adjustmentTypes}
                            getOptionLabel={(option) => option?.description || ''}
                            TextProps={{
                                label: 'Tipo de ajuste',
                                required: true,
                            }}
                            filterOptions={createFilterOptions({
                                stringify: (option) => option.description + option.code,
                            })}
                            renderOption={(props, option) => (
                                <li {...props}>
                                    <span color='secondary'>{`${option.code} - ${option.description}`}</span>
                                </li>)}
                        />
                    </Grid>
                    <Grid size={4}>
                        <Input
                            fullWidth
                            name='quantity'
                            label='Cantidad'
                            onChange={handleNumberChange}
                            value={quantity}
                            type='number'
                            inputProps={{
                                min: '1',
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

EditDetailModal.defaultProps = {
    onSave: () => { },
    onClose: () => { }
}

EditDetailModal.prototype = {
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    detail: PropTypes.object
}

export default EditDetailModal;